import { CommonDialogs } from "../../CommonDialogs";
import { MenuEditorDialogs } from "../MenuEditorDialogs";
import { MenuEditorTreeNode } from "../MenuEditorTreeNode";
import { MenuAction } from "./MenuAction";

export class MenuActionDelete extends MenuAction {

    override async internalExecute(): Promise<boolean> {
        return this.promptAndDelete();
    }

    private async promptAndDelete(): Promise<boolean> {
        if (this.node.isOnlyChild()) {
            return this.handleOnlyChild();
        }

        const confirmedNodes = await this.getConfirmedNodesToDelete();

        if (confirmedNodes != null) {
            this.deleteNodes(confirmedNodes);
            return true;
        }
        return false;
    }

    private async getConfirmedNodesToDelete(): Promise<MenuEditorTreeNode[] | null> {
        const nodesToDelete = this.getNodesMatchingThisMenuGroup();

        if (nodesToDelete.length === 1) {
            return await MenuEditorDialogs.showDeleteMenuItemDialog(nodesToDelete[0]);
        }

        if (this.node.menuItem.isSharedMenuReference()) {
            return await this.handleSharedReferencesDelete(nodesToDelete);
        }

        return await MenuEditorDialogs.showDeleteSharedItemsDialog(nodesToDelete);
    }

    private async handleOnlyChild(): Promise<boolean> {
        const parentCaption = this.parentNode.menuItem.caption;
        const message = `Unable to delete the only item in ${parentCaption}. Would you like to delete ${parentCaption} instead?`;

        const deleteParent = await CommonDialogs.showYesNo(message);
        if (deleteParent) {
            this.tree.selectedNode = this.parentNode;
            this.tree.menuEditor.executeDelete();
        }
        return false;
    }

    private async handleSharedReferencesDelete(nodes: MenuEditorTreeNode[]): Promise<MenuEditorTreeNode[] | null> {
        const confirmedNodes = await MenuEditorDialogs.showDeleteSharedReferencesDialog(nodes);
        if (confirmedNodes == null || confirmedNodes.length === 0) {
            return null;
        }
        return confirmedNodes;
    }

    private deleteNodes(nodes: MenuEditorTreeNode[]) {
        for (const node of nodes) {
            const parentNode = node.parent as MenuEditorTreeNode;
            const parentMenuItem = parentNode.menuItem;
            this.menuItemToSelect ??= parentMenuItem;
            parentMenuItem.removeChild(node.menuItem);
            this.menuDataSource.deleteMenuItem(node.menuItem);
        }
    }
}
